import styles from './SavingsSection.module.scss';

import React from 'react';
import { Container } from 'reactstrap';

import { ScrollOverPack, TweenOne, FadeUp, FadeLeft } from 'src/components/Animations';
import ButtonLink from 'src/components/ButtonLink';
import SavingsSlider from 'src/components/SavingsSlider';

export default (props) => (
  <div {...props} className={props.className} styleName='savings-section'>
      <ScrollOverPack component={Container} styleName='container'>
          <TweenOne key='text-container'
                    styleName='text-container'
                    {...FadeUp}>
              <div className='h2 text-white'>
                  Meaningful ROI right away
              </div>
              <div className='h3 text-teal-blue'>
                  See what you can save.
              </div>
              <div styleName='message'>
                  With just 10 minutes of setup, Galleon can add tens or hundreds
                  of thousands of dollars to your bottom line. That’s money you
                  can spend on marketing, customer service... or maybe even a nice
                  round of bonuses.
              </div>
              <ButtonLink to='/contact' styleName='button' outline>
                  Get a custom quote
              </ButtonLink>
          </TweenOne>
          <TweenOne key='savings-slider-container'
                    styleName='savings-slider-container'
                    {...FadeLeft}>
              <SavingsSlider styleName='savings-slider'/>
          </TweenOne>
      </ScrollOverPack>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/SavingsSection.js